import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
	getDocumentList,
	getObjectListWithDocs,
	getObjectListWithModels,
	getVersionList,
} from "./categorization.thunks";

interface CategorizationState {
	currentTab: string;
	documentList: any[];
	objectList: any[];
	detailedMode: boolean;
	versionMode: boolean;
	versionList: any[];
}

const initialState: CategorizationState = {
	currentTab: "",
	documentList: [],
	objectList: [],
	detailedMode: false,
	versionMode: false,
	versionList: [],
};

const categorizationSlice = createSlice({
	name: "categorizationSlice",
	initialState,
	reducers: {
		changeCurrentTab(state, action: PayloadAction<string>) {
			console.log("changeCurrentTab", action.payload);

			state.currentTab = action.payload;
			state.documentList = [];
			state.objectList = [];
		},
		changeDetaildeMode(state, action: PayloadAction<boolean>) {
			state.detailedMode = action.payload;
			state.documentList = [];
		},
		changeVersionMode(state, action: PayloadAction<boolean>) {
			state.versionMode = action.payload;
		},
		clearVersionList(state) {
			state.versionList = [];
		},
	},

	extraReducers: (builder) => {
		builder.addCase(getDocumentList.fulfilled, (state, action) => {
			state.documentList = action.payload as any;
		});
		builder.addCase(getObjectListWithModels.fulfilled, (state, action) => {
			state.objectList = action.payload;
		});
		builder.addCase(getObjectListWithDocs.fulfilled, (state, action) => {
			state.objectList = action.payload;
		});
		builder.addCase(getVersionList.fulfilled, (state, action) => {
			state.versionList = action.payload;
		});
	},
});

export const { changeCurrentTab, changeDetaildeMode, changeVersionMode, clearVersionList } =
	categorizationSlice.actions;
export default categorizationSlice.reducer;
